import { LowerCasePipe } from '@angular/common';
import { Component, inject, input, signal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import {
  InternalSimStates,
  PlanStateNames,
  StateNames,
  SubscriptionStatus,
} from '../../interfaces/sims';
import { GbTheme, THEME_SIGNAL } from '../../interfaces/theme';

@Component({
  selector: 'app-status-tag',
  imports: [TranslatePipe, LowerCasePipe],
  templateUrl: './status-tag.component.html',
  styleUrl: './status-tag.component.scss',
})
export class StatusTagComponent {
  public status = input.required<InternalSimStates>();
  public planStatus = input<SubscriptionStatus>();
  public label = input<string>();
  public position = input<string>('');

  public InternalSimStates = InternalSimStates;
  public StateNames = StateNames;
  public PlanStateNames = PlanStateNames;
  public theme = inject(THEME_SIGNAL);
  public GbTheme = GbTheme;

  public translatedText = signal<string>('');

  public displayKey(): string {
    const ps = this.planStatus();
    if (ps !== undefined) return PlanStateNames[ps];
    const l = this.label();
    if (l != null && l !== '') return l;
    return StateNames[this.status()];
  }
}
